<div
	[class]="'tag ' + colorClass"
	[ngClass]="{ 'tag-emphasized': isEmphasized }"
	data-test-class="tag"
>
	<ng-content />
</div>
